import Project from "./NuPro/Project";
import ProjectSatus from "./NuPro/ProjectSatus";
import Bids from "./NuPro/Bids";
import Budget from "./NuPro/Budget";
import Invoice from "./NuPro/Invoice";
import Due from "./NuPro/Due";
import Manpower from "./NuPro/Manpower";

function Dashboard() {
  return (
    <div className="w-[100%] h-[calc(100vh-145px)] py-2  overflow-y-auto">
      <div className="grid grid-cols-1 lg:grid-cols-8 gap-4">
        <div className="lg:col-span-2 lg:row-span-2">
          <Project />
        </div>
        <div className="lg:col-span-5 lg:row-span-2 lg:col-start-3">
          <ProjectSatus />
        </div>
        <div className="lg:row-span-2 lg:col-start-8 ">
          <Bids />
        </div>
        <div className="lg:col-span-4 lg:row-span-3 lg:row-start-3 ">
          <Budget />
        </div>
        <div className="lg:col-span-4 lg:row-span-3 lg:col-start-5 lg:row-start-3 ">
          <Invoice />
        </div>
        <div className="lg:col-span-5 lg:row-span-3 lg:row-start-6  ">
          <Due />
        </div>
        <div className="lg:col-span-3 lg:row-span-3 lg:col-start-6 lg:row-start-6 ">
          <Manpower />
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
